import { gql } from '@apollo/client';

const CREATE_ASSIGNMENT = gql`
  mutation createAssignment($data: AssignmentCreateInput!) {
    createAssignment(data: $data) {
      id
      students {
        id
        firstName
        lastName
      }
      character {
        character
      }
    }
  }
`;

export default CREATE_ASSIGNMENT;
